import React from 'react';

import { Container, Logo, FooterOption, Option, FooterSocial, SocialLogo,SubContainer } from './styles';

function Footer() {
  return (
    <Container>
      <SubContainer>
          <Logo src = "../../images/logo.svg" />
          <FooterOption>
              <Option>About</Option>
              <Option>Careers</Option>
              <Option>Events</Option>
              <Option>Products</Option>
              <Option>Support</Option>
          </FooterOption>
          <FooterSocial>
              <SocialLogo src = "../../images/icon-facebook.svg"/>
              <SocialLogo src = "../../images/icon-twitter.svg"/>
              <SocialLogo src = "../../images/icon-pinterest.svg"/>
              <SocialLogo src = "../../images/icon-instagram.svg"/>
          </FooterSocial>
          <p>&#169; 2021 Loopstudios. All rights reserved.</p>
        </SubContainer>
    </Container>
  );
}

export default Footer;